import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AddCall } from 'src/providers/addvCall';


@Component({
  selector: 'app-home-vc-notification',
  templateUrl: './home-vc-notification.page.html',
  styleUrls: ['./home-vc-notification.page.scss'],
})
export class HomeVcNotificationPage implements OnInit {

  // bookingcancel : any;
  // vc_callNotifiy : any;
  // remain_schedule : any;

  showtype: any; Docname: any; timeleft; any;


  constructor(public modelCtrl: ModalController,
    public addCall: AddCall,) {

  }

  ngOnInit() {
    // this.bookingcancel = 'true';
    // this.vc_callNotifiy = 'true';
    // this.remain_schedule = 'true';
  }


  dismiss() {
    this.modelCtrl.dismiss({

    });
  }


  closemodel(data) {
    // console.log(data);
    this.modelCtrl.dismiss(data);

  }

}
